import React from 'react';

export default class Content extends React.Component {
    render() {
        return (
            <div>Models</div>
        );
    }
}
